function roundNumber(num, scale) {
  if (!('' + num).includes('e')) {
    return +(Math.round(num + 'e+' + scale) + 'e-' + scale)
  } else {
    var arr = ('' + num).split('e')
    var sig = ''
    if (+arr[1] + scale > 0) {
      sig = '+'
    }
    return +(Math.round(+arr[0] + 'e' + sig + (+arr[1] + scale)) + 'e-' + scale)
  }
}

function todayMinusYears(yearCount) {
  const date = new Date('2019-04-29')
  return date.setFullYear(date.getFullYear() - yearCount)
}

function yymmddFrom(latestLastDay, minusYears) {
  const date = latestLastDay.date.slice(5)
  const year = parseInt(latestLastDay.date.trim(-5)) - minusYears
  return `${year}-${date}`
}

function toPercent(num, dem) {
  const percentage = (num / dem) * 100
  return isNaN(roundNumber(percentage, 2)) ? 0 : roundNumber(percentage, 2)
}
function percentChange(latest, old) {
  const percentage = ((latest - old) / old) * 100
  return isNaN(roundNumber(percentage, 2)) ? 0 : roundNumber(percentage, 2)
}

export { roundNumber, todayMinusYears, yymmddFrom, toPercent, percentChange }
